import { Injectable } from '@angular/core';

import { IntegrationsClientHttpBase } from '@recruitee/integrations/http';

@Injectable({ providedIn: 'root' })
export class IntegrationsClientHttp extends IntegrationsClientHttpBase {
  public get baseUrl(): string {
    return this.config.integrationsUrl;
  }
}
